import { Drawer , DrawerProps } from "antd";
import React, { ReactNode } from "react";

interface CustomDrawerProps extends Partial<DrawerProps> {
  mask?: boolean;
  loading?: boolean;
  title?: ReactNode | string;
  className?: string;
  placement?: "left" | "right" | "top" | "bottom";
  width?: string | number;
  closable?: boolean;
  openDrawer: boolean;
  closeDrawer: (value: boolean) => void;
  footer?: boolean;
  children?: ReactNode;
  bodyStyle?: React.CSSProperties;
}
/**
 * @author
 * @function @
 **/

export default (props: CustomDrawerProps) => {
  return (
    <Drawer
      mask={props?.mask}
      // loading={props?.loading}
      title={props?.title}
      className={props?.className}
      placement={props?.placement}
      width={props?.width ? props?.width : "378px"}
      closable={true}
      onClose={() => props?.closeDrawer(!props?.openDrawer)}
      open={props?.openDrawer}
      bodyStyle={props?.bodyStyle}
      footer={
        !props?.footer ? (
          <div
            style={{
              textAlign: "right",
              padding: "20px",
            }}
          ></div>
        ) : null
      }
    >
      {props?.children}
    </Drawer>
  );
};
